import { buttonReset } from 'components/Button/Button.styles'
import { styled } from 'stitches.config'

export const StickyFeedingBarRoot = styled('button', {
  ...buttonReset,
  cursor: 'pointer',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: 'rgba(253, 248, 239, 0.95)',
  boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.15)',
  padding: '20px $3 20px $10',

  '@bp1': {
    padding: '20px $3 20px $14',
  },

  '&:focus-visible': {
    outline: '2px solid $secondary-400',
    outlineOffset: '-2px',
  },
})

export const BarLabel = styled('span', {
  fontFamily: '$primary',
  fontWeight: '$semiBold',
  fontSize: '$body',
  color: '$accent-black',
})

export const ChevronIcon = styled('span', {
  display: 'flex',
  transform: 'rotate(-90deg)',
  transition: 'transform 0.2s ease',

  variants: {
    open: {
      true: {
        transform: 'rotate(90deg)',
      },
    },
  },
})
